import React, { useRef, useEffect, useState } from "react";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DataTable, DataTableDataSelectableParams } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../models/Login";
import { SendMassMail } from "./SendMassMail";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IFilter } from "./Filter";

export interface IMassMail {
  id?: number;
  fileName?: string;
  name?: string;
  email?: string;
  added_By?: string;
  subscribe: boolean;
  vendor_Company_Name?: string;
}

interface IProps {
  setModal: (modal: { open: boolean; singleData: IMassMail }) => void;
  tableData: IMassMail[];
  setTableData: React.Dispatch<React.SetStateAction<IMassMail[]>>;
  permissions: IPermissionProps;
  toast: any;
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
}

const EmptyMassMail: IMassMail = {
  fileName: "",
  name: "",
  email: "",
  subscribe: true,
};

export const Table = (props: IProps) => {
  const dt = useRef<any>(null);
  const dt2 = useRef<any>(null);
  const [limit, setLimit] = useState<number>(0);
  const [canSend, setCanSend] = useState(false);
  const [selectedRows, setSelectedRows] = useState<IMassMail[]>([]);
  const [openMail, setOpenMail] = useState({ open: false, multiData: [] } as {
    open: boolean;
    multiData: IMassMail[];
  });
  const [filters, setFilters] = useState<IFilter>(EmptyFilter);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyParams, setLazyParams] = useState<ILazyParams>({
    first: 0,
    rows: 25,
    page: 1,
    sortField: 'id',
    sortOrder: -1
  });

  const onPage = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
  }

  const onSort = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
  }

  //   const loadTableData = async () => {
  //   const response = await Fetch("MassMail", "GET", null, null, props.toast);
  //   if (response) {
  //     const data = await response.json();
  //     props.setTableData(data);
  //     console.log(data);
  //   }
  // };

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const loadTableData = async () => {
    const response = await Fetch("MassMail/getMassMailWithSelectingLimit", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filters=${JSON.stringify(filters)}`, props.toast);
    if (response) {
      const data = await response.json();
      setTotalRecords(prev => prev = data.totalRecords);
      setLimit(data.selectingLimit);
      setCanSend(data.canSend);
      props.setTableData(data.massMail);
    }
  };

  useEffect(() => {
    loadTableData();
  }, [filters, props.reload, lazyParams]);

  const isRowSelectable = (e: DataTableDataSelectableParams) => {
    const rowData = e.data as IMassMail;
    return rowData.subscribe === true;
  };

  // const onSelectionChange = (e: { value: IMassMail[] }) => {
  //   const next = e.value.filter(r => r.subscribe);

  //   if (next.length <= limit)
  //     return setSelectedRows(next);

  //   if (next.length - selectedRows.length > 1)
  //     return setSelectedRows(next.slice(0, limit));

  //   const added = next.find(r =>
  //     !selectedRows.some(s => s.id === r.id)
  //   );

  //   setSelectedRows([...selectedRows.slice(1),...(added ? [added] : [])]);
  // };

  const onSelectionChange = (e: { value: IMassMail[] }) => {
    const subscribedRow = e.value.filter((r) => r.subscribe);

    if (subscribedRow.length <= limit) return setSelectedRows(subscribedRow);

    if (subscribedRow.length - selectedRows.length > 1) return setSelectedRows(subscribedRow.slice(0, limit));

    if (subscribedRow.length > limit) {
      props.toast.current?.show({
        severity: "warn",
        summary: "Limit Exceeded",
        detail: `You can select up to ${limit} emails only`,
        life: 3000,
      });
      return;
    }
    setSelectedRows(subscribedRow);
  };

  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyMassMail });
  };

  const openEdit = (rowData: IMassMail) => {
    props.setModal({ open: true, singleData: rowData });
  };

  const openMassMailDailog = () => {
    setOpenMail({ open: true, multiData: selectedRows });
  };

  const actionBodyTemplate = (rowData: IMassMail) => (
    <div className="flex gap-2">
      <Button icon="pi pi-pencil text-primary" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
    </div>
  );

  // const leftToolbarTemplate = () => {
  //   if (canSend === true) {
  //     return <Button label="Upload" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />;
  //   } else {
  //     return null;
  //     // props.toast.current.show({
  //     //   severity: "warn",
  //     //   detail: "You are Not Allowed to Send Email, Only Experienced Can Send Email",
  //     //   life: 3000,
  //     // });
  //   }
  // };

  const leftToolbarTemplate = () => {
    return <Button label="Upload" icon="pi pi-plus" className="p-button-success mr-2" onClick={excelUpload} />;
  };

  const excelUpload = () => {
    if (!canSend) {
      props.toast.current?.show({
        severity: "warn",
        summary: "Permission Denied",
        detail: "You are Not Allowed to Send Email, Only Experienced Can Send Email",
        life: 3000,
      });
      return;
    }
    openNew();
  };

  const downloadSelected = () => {
    if (!selectedRows.length) {
      props.toast.current.show({
        severity: "warn",
        detail: "Please select at least one row",
        life: 3000,
      });
      return;
    }

    const headers = ["Name", "Email"];

    const rows = selectedRows.map((row) => [row.name ?? "", row.email ?? ""]);

    const csvContent = headers.join(",") + "\n" + rows.map((e) => e.join(",")).join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "selected_mass_mail.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadReferenceCSV = () => {
    const headers = ["Name", "Email"];
    const csvContent = headers.join(",") + "\n";

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "mass_mail_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const rightToolbarTemplate = () => (
    <>
      <div className="flex gap-3">
        <Button label="Download Sample Excel" icon="pi pi-upload" className="p-button-help" onClick={downloadReferenceCSV} />
        <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={downloadSelected} disabled={!selectedRows.length} />
        {selectedRows.length > 0 && <Button placeholder="Top" label="Send Mass Mail" icon="pi pi-envelope" onClick={() => openMassMailDailog()} />}
      </div>
    </>
  );

  return (
    <>
      {_roles.includes(1) || _roles.includes(26) ? (
        <Accordion>
          <AccordionTab header="Filter">
            <Filter filters={filters} setFilters={setFilters} />
          </AccordionTab>
        </Accordion>
      ) : (
        <></>
      )}
      <Toolbar className="mb-2" left={leftToolbarTemplate} right={rightToolbarTemplate} />

      <DataTable
        ref={dt}
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
        value={props.tableData}
        selection={selectedRows}
        onSelectionChange={onSelectionChange}
        size="small"
        isDataSelectable={isRowSelectable}
        lazy dataKey="id" showGridlines stripedRows responsiveLayout="scroll"
        paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200, 500, 1000]}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        emptyMessage="No Emails found."
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        totalRecords={totalRecords} onPage={onPage}
        scrollable
        scrollHeight="67vh"
      >
        {/* <Column
          field="sn"
          header="SN"
          body={(rowData, options) => options.rowIndex + 1}
        /> */}
        <Column selectionMode="multiple" style={{ width: "5rem", minWidth: "5rem", maxWidth: "5rem" }} headerStyle={{ width: "5rem" }} bodyStyle={{ textAlign: "center" }} />
        <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ width: "5rem", minWidth: "5rem", maxWidth: "5rem" }} />
        <Column field="name" header="Name" />
        <Column field="email" header="Email" />
        <Column field="vendor_Company_Name" header="Company Name" />
        <Column field="subscribe" header="Subscribe Status" body={(rowData: IMassMail) => <p style={{ color: rowData.subscribe === true ? "darkgreen" : "red" }}>{rowData.subscribe === true ? "Subscribe" : "Unsubscribe"}</p>} />
        <Column field="added_By" header="Added By" />
        <Column header="Action" body={actionBodyTemplate} />
      </DataTable>
      <SendMassMail
        open={openMail.open}
        multiData={openMail.multiData}
        hideDialog={() => {
          setOpenMail({ open: false, multiData: [] });
          setSelectedRows([]);
        }}
        toast={props.toast}
      />
      <ConfirmDialog />
    </>
  );
};
